import React from 'react';

interface LabelBoxProps{
    label:string;
    value: string|number;
}
const LabelBox:React.FC<LabelBoxProps> = (props) => {
  return (
    <div className='text-[12px] px-2 py-0.5 flex justify-end'>
        <h1 className='text-sky-900 text-opacity-70 font-medium dark:text-slate-400'><span>{`${props.label}:`}</span> <span className='text-green-500'> {props.value}</span></h1> 
    </div>
  )
}

export default LabelBox